(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["argoid-customer-viewed-this-also-viewed-this"] && !window.DesignMode) return;
  try {
    
    renderRecommendations(argoidCustomerViewedThisAlsoViewedThis);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoid-recommended-for-you"] && !window.DesignMode) return;
  try {
    
    renderRecommendations(argoidRecommendedForYou);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoid-similar-products"] && !window.DesignMode) return;
  try {
    
    renderRecommendations(argoidSimilarProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoid-trending-products"] && !window.DesignMode) return;
  try {
    
    renderRecommendations(argoidTrendingProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoid-you-may-also-like"] && !window.DesignMode) return;
  try {
    
    renderRecommendations(argoidYouMayAlsoLike);

  } catch(e) { console.error(e); }
})();

})();
